$ = require 'jquery'
Auth = require 'db/auth'
BoardListSectionHeaderComponent = require 'views/board-list/board-list-section-header-component'
BoardListSectionHeaderLinkComponent = require 'views/board-list/board-list-section-header-link-component'
BoardsPageDueSoonInfoView = require 'views/member/boards-page-due-soon-info-view'
f = require 'effing'
l = require 'lib/localize'
Label = require 'models/label'
PopOver = require 'views/lib/pop-over'
React = require 'react'
t = require('views/internal/recup-with-helpers')('boards_page_due_soon')
track = require 'debug/track'
Util = require 'lib/util'
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'

class BoardsPageDueSoonComponent extends React.Component
  displayName: 'BoardsPageDueSoonComponent'

  constructor: (props) ->
    @state =
      dueSoonCards: []

    @clickMarkAsComplete = @clickMarkAsComplete.bind(@)
    @trackOnClickInfoButton = @trackOnClickInfoButton.bind(@)
    @trackOnClickCanonicalCard = @trackOnClickCanonicalCard.bind(@)

  componentDidMount: ->
    { getDueSoonCards } = @props

    getDueSoonCards.then (dueSoonCards) =>
      @setState
        dueSoonCards: dueSoonCards

  trackOnClickInfoButton: (e) ->
    Util.preventDefault(e)
    PopOver.toggle
      elem: $('.js-due-soon-info')
      view: new BoardsPageDueSoonInfoView({ memberId: Auth.me().get('id') })
    track('Boards View', 'Due Soon', 'Clicked info button')
    return

  trackOnClickCanonicalCard: ->
    track('Boards View', 'Due Soon', 'Clicked on card')

  clickMarkAsComplete: (card) ->
    card.update({
      dueComplete: true
    })

    @setState (prevState, props) ->
      dueSoonCards: prevState.dueSoonCards.filter (i) -> i != card

    track('Boards View', 'Due Soon', 'Clicked Mark as complete')

  render: t.renderable ->
    { dueSoonCards } = @state

    if dueSoonCards.length
      t.div '.due-soon-cards.boards-page-board-section.mod-no-sidebar', =>
        t.addElement React.createElement BoardListSectionHeaderComponent, {
          title: l('board section title.due soon')
          iconClass: 'clock'
          linkElements: [
            {
              url: '#',
              iconClass: 'information',
              linkClasses:
                'js-due-soon-info': true,
                'due-soon-info': true
              titleKey: 'info',
              trackOnClick: @trackOnClickInfoButton
            }
          ].map(f.choke(1, React, 'createElement', BoardListSectionHeaderLinkComponent))
        }

        t.ul '.boards-page-board-section-list', =>
          dueSoonCards.map (card, index) =>
            if index < 4
              t.li '.boards-page-board-section-list-item', =>
                t.div { onClick: @trackOnClickCanonicalCard }, ->
                  t.tag CanonicalCard, {
                    board: card.getBoard()
                    boardClassName: 'canonical-stretch'
                    canRemove: false
                    card
                    cardClassName: 'canonical-stretch'
                    labels: card.getLabels().sort(Label.compare)
                    list: card.getList()
                    members: card.memberList.models
                    numNotifications: 0
                }

                if !card.getBoard().isObserver(Auth.me())
                  t.addElement React.createElement MarkAsCompleteComponent, { card, clickMarkAsComplete: @clickMarkAsComplete }
    else
      t.div()


MarkAsCompleteComponent = t.renderable ({ card, clickMarkAsComplete }) ->
  t.a '.mark-as-complete.button-link', { onClick: (e) -> clickMarkAsComplete(card) }, ->
    t.span '.icon-sm.icon-check', ->
    t.format 'mark-as-complete'

module.exports = {
  BoardsPageDueSoonComponent
}



// WEBPACK FOOTER //
// ./app/scripts/views/member/boards-page-due-soon-component.coffee